import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=7ab09ee2&scoped=true&"
import script from "./ProductDetails.vue?vue&type=script&lang=js&"
export * from "./ProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab09ee2",
  null
  
)

export default component.exports